const pool = {
  P: 0, // play 节点
  C: 0, // collect 节点
  J: 0, // jump 节点
  D: 0, // condition 节点
  L: 0, // llm 节点
  O: 0, // out 出口
  F: 0, // flowId
  I: 0, // intent
  V: 0, // 录音
  K: 0, // knowledge
  S: 0, // apiSettings
}

window.pool = pool;

export function resetNodeIds() {
  ['P', 'C', 'J', 'O', 'F', 'I', 'V', 'K', 'S'].forEach(k => {
    resetId(k)
  })
}

export function resetId(key) {
  pool[key] = 0;
}

export function setNodeIdPool(nodeId) {
  if (!nodeId) return;
  const { prefix, id } = resolve(nodeId)
  // 不设置比当前值小的值
  if (pool[prefix] >= id) return;
  pool[prefix] = id;
}

// 添加id 并返回新id
export function addNodeId(key) {
  if (!pool[key]) pool[key] = 0;
  pool[key]++;
  return `${key}${addLeftZero(pool[key])}`;
}

// 左补零
export function addLeftZero(i) {
  let numStr = i.toString();
  let c = numStr.length - 5;
  let r = "";
  while (c < 0) {
    r += "0";
    c++;
  }
  r += numStr;
  return r;
}

// 分解
function resolve(nodeId) {
  const prefix = nodeId.substring(0, 1);
  const id = parseInt(nodeId.substring(1));
  return { prefix, id }
}

// 池子前缀:与 pool 的 keys 对齐
const ID_PATTERN = /^[PCJDLOFIVKS]\d+$/;

// 递归遍历 sceneJson,把所有形如 V00001/P00001 的字符串喂给池子
// 对象的值和键都会检查(apiSettings 用 id 作为对象 key)
function collectIds(node) {
  if (node == null) return;
  if (typeof node === 'string') {
    if (ID_PATTERN.test(node)) setNodeIdPool(node);
    return;
  }
  if (Array.isArray(node)) {
    for (const item of node) collectIds(item);
    return;
  }
  if (typeof node === 'object') {
    for (const key of Object.keys(node)) {
      if (ID_PATTERN.test(key)) setNodeIdPool(key);
      collectIds(node[key]);
    }
  }
}

// 读取数据中的id
export function resetAllId(sceneJson) {
  collectIds(sceneJson);
  console.log('pool', pool)
  return 1;
}

/**
 * 处理重复id或空id
 */
export const handlerId = (sceneJson) => {

}